import { buyPlanApps, cancelPlanApp, getPlanApps, getPlans, getSubscribedPlanApps } from "../../../../RestApi/SystemApi";

export const getPlansListingHelper = (data) => {
  return new Promise((resolve, reject) => {
    getPlans(data)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        return reject({
          status: false,
          message: getResponseError(error),
        });
      });
  });
};

export const getPlanAppsHelper = (data) => {
  return new Promise((resolve, reject) => {
    getPlanApps(data)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        return reject({
          status: false,
          message: getResponseError(error),
        });
      });
  });
};

export const getSubscribedPlanAppsHelper = (data) => {
  return new Promise((resolve, reject) => {
    getSubscribedPlanApps(data)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        return reject({
          status: false,
          message: getResponseError(error),
        });
      });
  });
};

export const cancelPlanAppHelper = (data, id) => {
  return new Promise((resolve, reject) => {
    cancelPlanApp(data, id)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        return reject({
          status: false,
          message: getResponseError(error),
        });
      });
  });
};

export const buyPlanAppsHelper = (data, id) => {
  return new Promise((resolve, reject) => {
    buyPlanApps(data, id)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        return reject({
          status: false,
          message: getResponseError(error),
        });
      });
  });
};

export const getResponseError = (error) => {
    let responseError = error.response.statusText && error.response.statusText;
    if (error.response.data && error.response.data.message) {
      responseError = error.response.data.message;
    } else if (error.response.data.message) {
      responseError = error.message;
    }
    return responseError;
  };
  